import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RightsAccess, TabsToRightKeys } from '../../helper';
import { useComponent } from '../../../Pages/UserSetting/UsersLibrary/UserRights';
import MenuItem from '../MenuItem';
import {
  CostingToDoIcon,
  InboxIcon,
  ProgressIndicatorIcon,
  PurchaseOrderToDoIcon,
  SamplesToDoIcon,
  SubmitAndDownloadIcon,
  SupplierSuggestIcon,
  SupplierToDoIcon,
  SupportingDocumentsIcon,
  TestingToDoIcon,
} from '../../../bombiix-icon';

const TODO_TAB_ICONS = {
  'my-todo': InboxIcon,
  'progress-indicator': ProgressIndicatorIcon,
  samples: SamplesToDoIcon,
  'supporting-documents': SupportingDocumentsIcon,
  'supplier-todo': SupplierToDoIcon,
  suggestion: SupplierSuggestIcon,
  costing: CostingToDoIcon,
  'purchase-order': PurchaseOrderToDoIcon,
  'product-purchase-order-todo': PurchaseOrderToDoIcon,
  'submit-download': SubmitAndDownloadIcon,
  testing: TestingToDoIcon,
};

function TodoListUrl({ isMobileMenu }) {
  const { t } = useTranslation('common');

  const { pathname } = useLocation();
  const reducers = useSelector((redState) => redState);
  const {
    SampleTodoListData: { todoListTabs },
    UserDetails: { canSuggest, isSupplierLoggedIn, isCompanyAdminLoggedIn },
    Users: { logInRights, moduleAccess },
  } = reducers;

  const { checkRightWithKey, TestingRight } = RightsAccess();
  const { CheckModulePermission } = useComponent();
  const obj = {
    samples: 'samples',
    costing: 'costing',
    'product-purchase-order-todo': 'purchaseOrder',
  };

  const modalCheck = (name) => {
    if (name === 'suggestion') {
      return moduleAccess?.supplierOverviewAccess;
    }

    if (isCompanyAdminLoggedIn) {
      return true;
    }

    return CheckModulePermission(logInRights, 'products', obj[name]);
  };

  const checkModalAccess = (name) => {
    return ['progress-indicator', 'submit-download', 'product-purchase-order-todo'].includes(name) ? true : modalCheck(name);
  };

  return (
    <ul>
      {todoListTabs
        ?.filter((val) => !val.hide)
        ?.map((tabs) => {
          if (
            (tabs.type === 'suggestion' && isSupplierLoggedIn && !canSuggest) ||
            (['costing', 'suggestion', 'product-purchase-order-todo'].includes(tabs.type) && !checkRightWithKey(TabsToRightKeys[tabs?.type]))
          ) {
            return null;
          }
          if (tabs.type === 'testing' && !TestingRight) {
            return null;
          }
          return (
            checkModalAccess(tabs?.type) && (
              <MenuItem
                key={tabs?.type}
                activeClassList={[tabs?.url]}
                pathName={pathname}
                linkTo={`/todo-list/${tabs.url}`}
                IconComponent={TODO_TAB_ICONS[tabs?.type] || InboxIcon}
                titleKey={tabs.tabName}
                badgeData={{ count: tabs.count, color: tabs.colour || 'amber' }}
                isMobileMenu={isMobileMenu}
              />
            )
          );
        })}
    </ul>
  );
}

export default TodoListUrl;
